<div class="bg-light w-100">
  <month-requirement
    *ngFor="let requirement of bankRequirements; let i = index;"
    [requirement]="requirement"
    [borrowerId]="borrowerId"
    class="d-flex py-1 justify-content border-bottom border-gray-300"
    [ngClass]="{ 'border-bottom-0': i + 1 === bankRequirements.length && !processBtnVisible }"
  ></month-requirement>
  <div *ngIf="errorMessage" class="alert alert-danger small m-0 mh-3 mt-3" [@fade]>
    <strong>{{ errorMessage }}</strong>
  </div>
  <button
    *ngIf="processBtnVisible"
    class="btn btn-primary float-right mt-3 mb-3"
    [disabled]="processBtnDisabled"
    (click)="process($event)">Process
  </button>
</div>
